import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getNewApplicant from '../services/partners/getNewApplicant';
import postApproveNewPartner from '../services/partners/postApproveNewPartner';

// THUNKS
export const listNewPartnerApplicant = createAsyncThunk('application.partners/getNewApplicant', getNewApplicant.handler);
export const approveNewPartner = createAsyncThunk('application.partners/approveNewPartner', postApproveNewPartner.handler);

const user_initial_state = {
  lists: [],
  next_token: null,
};

// slice definition
const slice = createSlice({
  name: 'application.partners',
  initialState: user_initial_state,
  reducers: {},
  extraReducers: builder => {
    builder

      // dehydrateUser
      .addCase(listNewPartnerApplicant.pending, getNewApplicant.pending)
      .addCase(listNewPartnerApplicant.fulfilled, getNewApplicant.fulfilled)
      .addCase(listNewPartnerApplicant.rejected, getNewApplicant.rejected)

      // approveNewPartner
      .addCase(approveNewPartner.pending, postApproveNewPartner.pending)
      .addCase(approveNewPartner.fulfilled, postApproveNewPartner.fulfilled)
      .addCase(approveNewPartner.rejected, postApproveNewPartner.rejected)
  },
});

// export const { mutateUserProfile } = slice.actions;
const { reducer } = slice;
export default reducer;